export default "__VITE_ASSET__DtxWtRmS__"